import type { ReceivedAddress } from '@t/serviceQualification.types';
import { formatStructuredAddress } from '@utils/formatStructuredAddress';

export const formatReceivedAddress = (address: ReceivedAddress): string =>
  formatStructuredAddress({ ...address, postalCode: address.postCode });
